import { connect } from 'react-redux';
import * as actions from './actions';

const mapStateToProps = (state) => {
  const {
    localize: { locale },
  } = state;
  return {
    locale
  }
};

export default WrappedComponent => connect(
  mapStateToProps,
  actions,
  null,
  { pure: false }
)(WrappedComponent);




// WEBPACK FOOTER //
// ./src/modules/localization/withLocalized.js